"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var preact_1 = require("preact");
var SignupContext_1 = require("../SignupContext");
var hooks_1 = require("preact/hooks");
var ThankYou = function (_a) {
    var discountTermsAgain = _a.discountTermsAgain, code = _a.code;
    var setModalOpen = (0, hooks_1.useContext)(SignupContext_1.SignupContext).setModalOpen;
    return ((0, preact_1.h)("div", { class: "signup-thanks" },
        (0, preact_1.h)("div", { class: "signup-thanks__top" },
            (0, preact_1.h)("p", { class: "signup-thanks__text signup-thanks__text--extrabold" }, "Thanks for signing up!"),
            (0, preact_1.h)("br", null),
            (0, preact_1.h)("p", { class: "signup-thanks__text" },
                (0, preact_1.h)("span", { class: "signup-thanks__text" },
                    "Get ",
                    discountTermsAgain,
                    " by"),
                (0, preact_1.h)("br", null),
                " using the code below")),
        (0, preact_1.h)("div", { class: "signup-thanks__text signup-thanks__text--extrabold signup-thanks__text--code" }, code),
        (0, preact_1.h)("button", { class: "signup-thanks__button", onClick: function () {
                setModalOpen(false);
            } }, "SHOP NOW")));
};
exports.default = ThankYou;
